<template>
  <div class="pl-20 pr-20">
    <div class="flex a-center">
      <div>运单状态：</div>
      <div>
        <!-- <a-badge :count="orderGetTicketCount"> -->
          <a-radio-group v-model="params.orderState" button-style="solid">
            <a-radio-button value="">
              全部
            </a-radio-button>
            <a-radio-button :value="1">
              已揽件
            </a-radio-button>
            <a-radio-button :value="2">
              在途中
            </a-radio-button>
            <a-radio-button :value="3">
              已签收
            </a-radio-button>
            <a-radio-button :value="0">
              无轨迹
            </a-radio-button>
            <a-radio-button :value="4">
              问题件
            </a-radio-button>

            <a-radio-button value="C00">
              在线投诉反馈
            </a-radio-button>
          </a-radio-group>
        <!-- </a-badge> -->

      </div>
    </div>
    <div class="mt-20 flex a-center">
      <div class="flex a-center ">
        <div>下单时间：</div>
        <div>
          <a-radio-group v-model="timeSestion" button-style="solid">
            <a-radio-button :value="0">
              全部
            </a-radio-button>
            <a-radio-button :value="1">
              昨天
            </a-radio-button>
            <a-radio-button :value="2">
              今天
            </a-radio-button>
            <a-radio-button :value="3">
              近7天
            </a-radio-button>
            <a-radio-button :value="4">
              自定义
            </a-radio-button>
          </a-radio-group>
        </div>
        <div><a-range-picker v-if="timeSestion === 4" v-model="time" class="w-302" /></div>
      </div>
    </div>
    <div class="mt-20 flex a-center flex-wrap">

      <div class="flex a-center mr-20 mb-20">
        <div class="">物品名称：</div>
        <div><a-input v-model="params.cargoName" placeholder="请输入物品名称" type="text" /></div>
      </div>
      <div class="flex a-center mr-20 mb-20">
        <div class="">快递单号：</div>
        <div><a-input v-model="params.logisticCode" placeholder="请输入快递单号" type="text" /></div>
      </div>
    </div>
    <div class="flex a-center  flex-wrap">
      <div class="flex a-center mr-20 mb-20">
        <div>寄件姓名：</div>
        <div><a-input v-model="params.fromName" placeholder="请输入寄件人姓名" type="text" /></div>
      </div>
      <div class="flex a-center mr-20 mb-20">
        <div class="">寄件手机：</div>
        <div><a-input v-model="params.fromMobile" placeholder="请输入寄件人手机" type="text" /></div>
      </div>
      <div class="flex a-center mr-20 mb-20">
        <div class="">收件姓名：</div>
        <div><a-input v-model="params.toName" placeholder="请输入收件人姓名" type="text" /></div>
      </div>
      <div class="flex a-center mr-20 mb-20">
        <div class="">收件手机：</div>
        <div><a-input v-model="params.toMobile" placeholder="请输入收件人手机" type="text" /></div>
      </div>

      <div class="flex a-center mr-20 mb-20">
        <div class="">快递公司：</div>
        <div>
          <a-select v-model="params.shipperCode" placeholder="请输入快递公司" class="w-174">
            <a-select-option v-for="(i,index) in companys" :key="index" :value="i.shipperCode">{{ i.shipperName }}</a-select-option>
          </a-select>
        </div>
      </div>

      <div class="flex a-center mr-20 mb-20" v-if="$store.state.user.role === 3">
        <div class="">员工账号：</div>
        <div>
          <a-select v-model="params.originCustomerId" placeholder="请选择员工" class="w-174">
            <!-- <a-select-option >清选择</a-select-option> -->
            <a-select-option v-for="(i,index) in staffList" :key="index" :value="i.userid">{{ i.staffname }}</a-select-option>
          </a-select>
        </div>
      </div>
      <div class=" mb-20"><a-button type="primary" @click="search">查 询</a-button> <a-button @click="reset">清 空</a-button> <a-button @click="expExcel">导出excel</a-button></div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
// 1.导出excel
// 2.反馈过的数量
export default {
  data() {
    return {
      timeSestion: '',
      time: null,
      companys: [],
      orderGetTicketCount: 0,
      staffList: [],
      params: {
        originCustomerId: undefined,
        orderState: '',
        'cargoName': '',
        'endCreateDate': '',
        'fromMobile': '',
        'fromName': '',
        'shipperCode': undefined,
        'startCreateDate': '',
        'toName': '',
        logisticCode: '',
        monitorStatus: ''
      }
    }
  },
  watch: {
    timeSestion(n) {
      if (n === 1) {
        this.params.startCreateDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
        this.params.endCreateDate = this.params.startCreateDate
      } else if (n === 2) {
        this.params.startCreateDate = moment().format('YYYY-MM-DD')
        this.params.endCreateDate = this.params.startCreateDate
      } else if (n === 3) {
        this.params.startCreateDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
        this.params.endCreateDate = moment().format('YYYY-MM-DD')
      } else if (n === 4) {
        this.params.startCreateDate = ''
        this.params.endCreateDate = ''
      } else if (n === 0) {
        this.params.startCreateDate = ''
        this.params.endCreateDate = ''
      }
    },
    time(n) {
      if (!n || !n.length) {
        this.params.startCreateDate = ''
        this.params.endCreateDate = ''
      } else {
        this.params.startCreateDate = n[0].format('YYYY-MM-DD')
        this.params.endCreateDate = n[1].format('YYYY-MM-DD')
      }
    }
  },
  async created() {
    const res = await this.$http(this.$api.logisticsGetList)
    this.companys = res || []
    const staffList = await this.$http(this.$api.staffGetStaffList, {})
    this.staffList = staffList || []

    this.timeSestion = 0
    if (this.$route.query.m) {
      this.params.monitorStatus = +this.$route.query.m
      this.timeSestion = 3
    }
    if (this.$route.query.s) {
      this.params.orderState = +this.$route.query.s
    }
    this.$nextTick(() => {
      const p = sessionStorage.getItem('searchParams')
      if (p) {
        const params = JSON.parse(p)
        this.timeSestion = 4
        this.time = params.createTimeStart && params.createTimeEnd ? [moment(params.createTimeStart), moment(params.createTimeEnd)] : null
        // this.params.fromName = params.staffName
        this.params.shipperCode = params.shipperCode || undefined
        this.params.originCustomerId = +params.originCustomerId
        sessionStorage.removeItem('searchParams')
      }
      this.$emit('search', this.params)
    })
    this.getCount()
  },
  methods: {
    async getCount() {
      this.orderGetTicketCount = await this.$http(this.$api.orderGetTicketCount)
    },
    expExcel() {
      this.$emit('expExcel', this.params)
    },
    search() {
      this.params.monitorStatus = ''
      this.$emit('search', this.params)
    },
    reset() {
      this.time = null
      this.timeSestion = 2
      Object.assign(this.params, {
        orderState: '',
        'cargoName': '',
        'endCreateDate': '',
        'fromMobile': '',
        'fromName': '',
        'shipperCode': '',
        'startCreateDate': '',
        'toName': '',
        logisticCode: '',
        monitorStatus: '',
        originCustomerId: undefined
      })
      console.log(this.params)
      this.$nextTick(() => {
        this.$emit('reset', this.params)
      })
    }
  }
}
</script>
